var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserProfileGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#E6E7F0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0001 4.5C7.39782 4.5 6.0751 5.76304 6.0751 7.35C6.0751 8.93696 7.39782 10.2 9.0001 10.2C10.6024 10.2 11.9251 8.93696 11.9251 7.35C11.9251 5.76304 10.6024 4.5 9.0001 4.5ZM6.5251 11.7C5.75373 11.7 5.01127 11.997 4.46174 12.5299C3.91174 13.0632 3.6001 13.7896 3.6001 14.55C3.6001 14.6926 3.66767 14.8267 3.78225 14.9116L7.6501 17.6225C7.8498 17.7704 8.31377 18.0176 8.4617 17.8179C8.57169 17.6694 8.57669 17.4755 8.48994 17.325H10.3501C10.3501 17.4307 10.3871 17.5369 10.4624 17.6225C10.6267 17.8089 10.9111 17.8269 11.0976 17.6627L14.2476 14.8877C14.3445 14.8022 14.4001 14.6792 14.4001 14.55C14.4001 13.7896 14.0885 13.0632 13.5385 12.5299C12.9889 11.997 12.2465 11.7 11.4751 11.7H6.5251Z",
    fill: "#454A67"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 7.5,
    stroke: "#9296AC",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfileGray);
export default __webpack_public_path__ + "static/media/userProfileGray.bc0d37976dec4c2aa788b3e1ac2e2cb6.svg";
export { ForwardRef as ReactComponent };